module.exports = (__webpack_require__(12))(41);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/large_image/web_client/collections/ElementCollection.js from dll-reference girder_plugin_large_image
// module id = 132
// module chunks = 0